import "./Projects.css";
import Box8_image from "../../assets/Box8.png"; 
import foodRecipeWebsite_image from "../../assets/foodRecipeWebsite.png"; 
import apartmentManager from "../../assets/apartmentManager.png";
import task_manager from "../../assets/task_manager.png";

const data = [
    {
        id : "1",
        image : Box8_image,
        projectName : "Box8.in-clone",
        projectDesc : "An online food ordering website executed in 3 days by a group of 5 members. I designed and implemented all the functionalities of the product page on this website.",
        github : "https://github.com/Gourav135/Box8.in.git",
        liveDemo : "https://gourav135.github.io/Box8.in/"
    },
    {
        id : "2",
        image : foodRecipeWebsite_image,
        projectName : "Food Recipe Website",
        projectDesc : "A website where you can search and explore recipes of varieties of dishes. It is a solo project executed in two days using tech stacks like HTML, CSS & JS only.",
        github : "https://github.com/dk-jaiswal-77/foodRecipeWebsite.git",
        liveDemo : "https://food-recipe-website-brooiw4on-dkjaiswal771999-gmailcom.vercel.app"
    },
    {
        id : "3",
        image : apartmentManager,
        projectName : "Apartment Manager",
        projectDesc : "It is an web application that allows respective manager of an apartment to add, view & update flats' details & residents' details. It is a solo project executed in two days using tech stacks like React, Redux, MongoDB and Express.",
        github : "https://github.com/dk-jaiswal-77/apartment_manager_frontend.git",
        liveDemo : "https://apartment-manager-frontend-hazel.vercel.app/" 
    }, 
    {
        id : "4",
        image : task_manager,
        projectName : "Task Manager",
        projectDesc : "A web application that allows user to create task with subtasks, edit, update and delete task. This app self categories the task into three categories and automatically chages the status of task upon completion of subtasks.",
        github : "https://github.com/dk-jaiswal-77/task-manager-frontend.git",
        liveDemo : "https://task-manager-frontend-peach.vercel.app/" 
    }
];   

export default function Projects(){
    return(
        <section id="projects">

            <h5>My Recent Work</h5> 
            <h2>Projects</h2>

            <div className="container projects__container">

                {
                    data.map(({id, image, projectName, projectDesc, github, liveDemo})=>{
                        return (
                            <article className="project__item" key={id} >

                                <div className="project__item-image">
                                    <img src={image} alt="project_image" />
                                </div>

                                <h3>{projectName}</h3>

                                <p className="project_desc">{projectDesc}</p>

                                <div className="project__item-cta">
                                    <a href={github} className="btn" target="_blank" >Github</a>
                                    <a href={liveDemo} className="btn btn-primary" target="_blank" >Live Demo</a>
                                </div>   

                            </article>
                        );
                    })
                }

            </div>

        </section>
    );
}